module.exports = __webpack_public_path__ + "assets/img/high-severity-statistics.44ed4fd0.png";